import { render } from "./profile-onboarding.vue?vue&type=template&id=255b218a&scoped=true"
import script from "./profile-onboarding.vue?vue&type=script&lang=js"
export * from "./profile-onboarding.vue?vue&type=script&lang=js"

import "./profile-onboarding.vue?vue&type=style&index=0&id=255b218a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255b218a"]])

export default __exports__